import React from 'react';
import '../less/installment_from_statement.less';
import {Preloader} from 'MWC';
import {Link} from 'MWComponents';
import Calculator from '../../../auxiliary-components/Calculator';
import TabsNew from '../../../auxiliary-components/shared/TabsNew';
import UsageBlock from '../../../auxiliary-components/shared/UsageBlock';
import Banner from '../../../auxiliary-components/shared/Banner';
import QuestionsBlock from '../../../auxiliary-components/shared/QuestionsBlock';
import TextAboveFooter from '../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c';
import installment_from_statement_banner_img from '../img/installment_from_statement_banner_img.png';
import usage_block_data from '../enums/installment_from_statement_usage_block-new.json';
import repayment_usage_block_data from '../enums/installment_from_statement_repayment_usage_block.json';
import questions from '../enums/installment_from_statement_questions.json';
import {downloadA24} from '../../../services/urls/urls';
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import how_to_1 from "../img/inst_from_statement/how_to_5.png";
import how_to_2 from "../img/inst_from_statement/how_to_6.png";
import how_to_3 from "../img/inst_from_statement/how_to_7.png";
import HowToBlock from "../../../auxiliary-components/shared/HowToBlock";
import shop_icon_15 from "../../Business/img/shop_icon_15.svg";
import {
  allo,
  comfy,
  ctrs, epicentrk,
  foxtrot,
  jabko,
  moyo,
  rozetka,
  touch,
  ukrzoloto,
  yabloki,
  zolotoyvek
} from "../../../services/urls/urls";
import shop_icon_12 from "../../Business/img/shop_icon_12.svg";
import shop_icon_13 from "../../Business/img/shop_icon_13.svg";
import shop_icon_7 from "../../Business/img/shop_icon_7.svg";
import shop_icon_2 from "../../Business/img/shop_icon_2.svg";
import shop_icon_14 from "../../Business/img/shop_icon_14.svg";
import shop_icon_8 from "../../Business/img/shop_icon_8.svg";
import shop_icon_5 from "../../Business/img/shop_icon_5.svg";
import shop_icon_4 from "../../Business/img/shop_icon_4.svg";
import shop_icon_1 from "../../Business/img/shop_icon_1.svg";
import shop_icon_10 from "../../Business/img/shop_icon_10.svg";
import shop_icon_9 from "../../Business/img/shop_icon_9.svg";
import attention_img from "../../Business/img/attention_img.svg";

export default function template() {
    const isMobile = this.isViewportMobile(),
        page = 'pbp',
        model = this.getModel(),
        modes = [
            {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'repayment', title: 'INSTALLMENT_FROM_STATEMENT_NAV_TITLE_1'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}
        ],
      howToItems = [
          { img: how_to_1, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_5', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_5' },
          { img: how_to_2, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_6', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_6' },
          { img: how_to_3, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_7', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_7' }
      ],
      shops ={
          tech: [
            {title: 'PBP_ENTITY_SHOPS_ITEM_15', img: shop_icon_15, link: ctrs},
            {title: 'PBP_ENTITY_SHOPS_ITEM_12', img: shop_icon_12, link: moyo},
            {title: 'PBP_ENTITY_SHOPS_ITEM_13', img: shop_icon_13, link: foxtrot},
            {title: 'PBP_ENTITY_SHOPS_ITEM_7', img: shop_icon_7, link: touch},
            {title: 'PBP_ENTITY_SHOPS_ITEM_2', img: shop_icon_2, link: comfy},
            {title: 'PBP_ENTITY_SHOPS_ITEM_14', img: shop_icon_14, link: jabko},
            {title: 'PBP_ENTITY_SHOPS_ITEM_8', img: shop_icon_8, link: yabloki},
  
          ],
          loves: [
            {title: 'PBP_ENTITY_SHOPS_ITEM_5', img: shop_icon_5, link: zolotoyvek},
            {title: 'PBP_ENTITY_SHOPS_ITEM_4', img: shop_icon_4, link: ukrzoloto},
          ],
          big: [
            {title: 'PBP_ENTITY_SHOPS_ITEM_1', img: shop_icon_1, link: rozetka},
            {title: 'PBP_ENTITY_SHOPS_ITEM_10', img: shop_icon_10, link: epicentrk},
            {title: 'PBP_ENTITY_SHOPS_ITEM_9', img: shop_icon_9, link: allo},
          ]
        },
        shopsListTech = shops.tech.map(el => {
          return (
            <a key={el[0]} className='shops-block-item' href={el.link} target="_blank">
              <img src={el.img} alt={`${el.title}_IMG`}/>
              <div >{this.l10n(el.title)}</div>
            </a>
          )
        }),
        shopsListLoves = shops.loves.map(el => {
          return (
            <a key={el[0]} className='shops-block-item' href={el.link} target="_blank">
              <img src={el.img} alt={`${el.title}_IMG`}/>
              <div >{this.l10n(el.title)}</div>
            </a>
          )
        }),
        shopsListBig = shops.big.map(el => {
          return (
            <a key={el[0]} className='shops-block-item' href={el.link} target="_blank">
              <img src={el.img} alt={`${el.title}_IMG`}/>
              <div >{this.l10n(el.title)}</div>
            </a>
          )
        }),
        calculator = !model.creditSum ? (
            ''
        ) : (
            <div className='credit-calculator'>
                <div className='content'>
                    <Calculator
                        model={this.getModel()}
                        type={this.state.selectedType}
                        {...this.props}
                    />
                </div>
            </div>
        );

    return !model.creditSum ? (
        <div className='preload-wrapper'>
            <Preloader />
        </div>
    ) : (
        <>
            <div className='content'>
                <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} className="col-3-row-1"></UsageBlock>
            </div>
            <div className='content'>
              <div className='join-partners'>
                    <div className='text-part'>
                      <div className='text-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_1')}}></div>
                      <div className='text-part-attention'>
                        <img src={attention_img} alt="attention_img" />
                        <div className='text-part-attention-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_2')}}></div>
                      </div>
                      <a href={'/business/pbp-entity'} target='_self' className='text-part-text' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_4_2')}}></a>
                    </div>
                    <div className='shops-part'>
                      <div className='shops-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_5')}}></div>
                      <div className='shops-block'>
                        {shopsListTech}
                      </div>
                    </div>
                    <div className='shops-part'>
                      <div className='shops-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_6')}}></div>
                      <div className='shops-block'>
                        {shopsListLoves}
                      </div>
                      <div className='shops-part-title' dangerouslySetInnerHTML={{__html: this.l10n('PBP_ENTITY_PARTNERS_TEXT_7')}}></div>
                      <div className='shops-block'>
                        {shopsListBig}
                      </div>
                    </div>
              </div>
            </div>
            <div className='content'>
                <div className="how-to-block-wrapper">
                    <div className="block-title">{this.l10n("INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_NEW")}</div>
                    <HowToBlock data={howToItems} isMobile={isMobile} page={'pbp'}></HowToBlock>
                </div>
            </div>
            {calculator}

            <FilesForDownload page={'pbp'} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>

            <div
                className={`disclaimer-wrapper tab-${
                    this.props.page === 'installment' ? 'installment' : ''
                }`}
            >
                <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile} />
            </div>
        </>
    );
}
